export default {"src":"/_next/static/media/challenge-monthly-icon.375c0d87.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};